import React, { useState } from "react";
import { useStateContext } from "../contexts/ContextProvider";
import { FaChevronUp } from "react-icons/fa";
import { FaChevronDown } from "react-icons/fa";

const initialFaqStates = {
  general: false,
  pricing: false,
  leases: false,
};

const initialQuestionState = {
  1: false,
  2: false,
  3: false,
  4: false,
  5: false,
  6: false,
  7: false,
  8: false,
  9: false,
  10: false,
};

const Faq = (props) => {
  const { generalFaq, leasesFaq, pricingFaq } = props;
  const { faqClicked, setFaqClicked, handleFaqClick } = useStateContext();
  const [questions, setQuestions] = useState(generalFaq);

  const [showFaqs, setShowFaqs] = useState({
    general: true,
    pricing: false,
    leases: false,
  });

  const showFaq = (name) => {
    if (name === "general") setQuestions(generalFaq);
    if (name === "leases") setQuestions(leasesFaq);
    if (name === "pricing") setQuestions(pricingFaq);
    setFaqClicked(initialQuestionState);
    setShowFaqs({ ...initialFaqStates, [name]: !showFaqs[name] });
  };

  return (
    <>
      <div className="flex justify-center text-center text-3xl mt-10">
        Frequently Asked Questions
      </div>
      <div className="flex justify-center">
        <div className="flex justify-evenly w-full md:w-3/5 mt-10">
          <div
            className={`w-20 text-center rounded-md py-3 cursor-pointer ${
              showFaqs.general
                ? "bg-gray-200"
                : "text-gray-500 hover:bg-gray-200 hover:text-gray-600"
            }`}
            onClick={showFaqs.general ? () => {} : () => showFaq("general")}
          >
            General
          </div>
          <div
            className={`w-20 text-center rounded-md py-3 cursor-pointer ${
              showFaqs.leases
                ? "bg-gray-200"
                : "text-gray-500 hover:bg-gray-100 hover:text-gray-600"
            }`}
            onClick={showFaqs.leases ? () => {} : () => showFaq("leases")}
          >
            Leases
          </div>
          <div
            className={`w-20 text-center rounded-md py-3 cursor-pointer ${
              showFaqs.pricing
                ? "bg-gray-200"
                : "text-gray-500 hover:bg-gray-100 hover:text-gray-600"
            }`}
            onClick={showFaqs.pricing ? () => {} : () => showFaq("pricing")}
          >
            Pricing
          </div>
        </div>
      </div>
      <div className="text-center text-2xl md:text-3xl pb-5">
        <div className="flex justify-center">
          <ul className="text-left mx-5 md:w-3/5 ">
            {questions.map((item, index) => {
              return (
                <li key={index}>
                  <div
                    className={`  ${
                      faqClicked[index] ? "bg-gray-200" : "bg-gray-200"
                    } border-1 border-gray-400 p-5 my-5 rounded-md`}
                    onClick={() => handleFaqClick(index)}
                  >
                    <div className="grid grid-cols-6">
                      <div className="col-span-5 text-lg font-bold mr-2 ">
                        {item.question}
                      </div>
                      {faqClicked[index] ? (
                        <FaChevronUp className="h-full place-self-end text-base" />
                      ) : (
                        <FaChevronDown className="h-full place-self-end text-base" />
                      )}
                    </div>
                    {faqClicked[index] && (
                      <div
                        className="text-base mt-5 font-lease-2"
                        dangerouslySetInnerHTML={{ __html: item.answer }}
                      />
                      //   {item.answer}
                      // </div>
                    )}
                  </div>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </>
  );
};

export default Faq;
